module.exports = __webpack_public_path__ + "img/new_ls_logo.6b53b13e.png";